import { render, staticRenderFns } from "./ContextPlugin.vue?vue&type=template&id=a1628738&scoped=true"
import script from "./ContextPlugin.vue?vue&type=script&lang=js"
export * from "./ContextPlugin.vue?vue&type=script&lang=js"
import style0 from "./ContextPlugin.vue?vue&type=style&index=0&id=a1628738&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1628738",
  null
  
)

export default component.exports